var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverviewLightMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 49.027,
    viewBox: "0 0 53 49.027",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3686",
    "data-name": "Group 3686",
    transform: "translate(-130 -866)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Overview",
    transform: "translate(130 911.027)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Overview")), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Broken_Category",
    "data-name": "Iconly/Broken/Category",
    transform: "translate(138.1 862.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Category",
    transform: "translate(3.449 3.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Category-2",
    "data-name": "Category",
    d: "M20.238,28.9a4.46,4.46,0,0,1-4.373-4.478V20.057a4.423,4.423,0,0,1,4.373-4.463h4.278A4.458,4.458,0,0,1,28.9,20.057v4.367A4.477,4.477,0,0,1,24.516,28.9Zm-2.026-8.845v4.367a2.068,2.068,0,0,0,.59,1.466,1.976,1.976,0,0,0,1.421.6h4.308a1.976,1.976,0,0,0,1.421-.6,2.064,2.064,0,0,0,.589-1.466V20.057a2.081,2.081,0,0,0-.593-1.462,1.994,1.994,0,0,0-1.432-.605H20.238A2.049,2.049,0,0,0,18.212,20.057ZM4.385,28.888A4.527,4.527,0,0,1,0,24.411V20.057A4.511,4.511,0,0,1,1.286,16.9a4.323,4.323,0,0,1,3.1-1.3H6.143a1.17,1.17,0,0,1,1.125.559,1.225,1.225,0,0,1,0,1.277,1.171,1.171,0,0,1-1.125.56H4.385a2.06,2.06,0,0,0-2.038,2.067V24.37a2.1,2.1,0,0,0,2.038,2.067H8.691a2,2,0,0,0,1.44-.6,2.085,2.085,0,0,0,.6-1.466V17.894a1.214,1.214,0,0,1,.528-1.236,1.161,1.161,0,0,1,1.321.038,1.218,1.218,0,0,1,.457,1.266v6.448a4.431,4.431,0,0,1-4.385,4.477ZM22.8,13.349a1.208,1.208,0,0,1,0-2.4h1.717a2.013,2.013,0,0,0,1.442-.623,2.108,2.108,0,0,0,.583-1.485V4.477a2.075,2.075,0,0,0-2.025-2.067H20.238a2.047,2.047,0,0,0-2.026,2.067v6.53a1.2,1.2,0,0,1-1.206,1.177,1.157,1.157,0,0,1-.823-.372,1.207,1.207,0,0,1-.318-.86V4.477a4.513,4.513,0,0,1,1.276-3.165A4.33,4.33,0,0,1,20.238,0h4.278a4.526,4.526,0,0,1,4.371,4.477V8.83A4.512,4.512,0,0,1,27.646,12a4.335,4.335,0,0,1-3.076,1.347ZM8.673,13.308H4.385A4.461,4.461,0,0,1,0,8.844V4.477A4.476,4.476,0,0,1,4.385,0H8.663a4.457,4.457,0,0,1,4.386,4.477V8.844A4.482,4.482,0,0,1,11.764,12a4.3,4.3,0,0,1-3.09,1.3ZM2.927,3A2.1,2.1,0,0,0,2.32,4.477V8.844a2.1,2.1,0,0,0,.593,1.5,2.007,2.007,0,0,0,1.428.605H8.663a2,2,0,0,0,1.443-.623,2.094,2.094,0,0,0,.583-1.485V4.477A2.071,2.071,0,0,0,8.663,2.409H4.345A1.994,1.994,0,0,0,2.927,3Z",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewLightMobile);
export default __webpack_public_path__ + "static/media/overview-light-mobile.b1ea8b206e05b19dcbeb4b941421d49c.svg";
export { ForwardRef as ReactComponent };